/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Cargo_Supervision_DescriptionInputs */



/**
* | output |
* | --- |
* | "Independent supervision and attendance of cargo operations." |
*
* @param {Service_Cargo_Supervision_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_cargo_supervision_description = /** @type {((inputs?: Service_Cargo_Supervision_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Cargo_Supervision_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对货物作业进行独立的现场监督。")
	return /** @type {LocalizedString} */ ("Independent supervision and attendance of cargo operations.")
});